attachEvent('.recommended-products__wishlist-btn, .recommended-products__wishlist-btn-text', 'click', (ev) => {
  const likeIcon = ev.target.closest('button');
  const isActive = likeIcon.classList.contains('is-active');
  const allWishlistButtons = document.querySelectorAll('.recommended-products__list .card__wishlist-button');

  likeIcon.classList.toggle('is-active', !isActive);
  allWishlistButtons.forEach((button) => {
    button.classList.toggle('is-liked', !isActive);
  });
  const productsIds = [];
  document.querySelectorAll('.recommended-products__list .card .open-wishlist-popup').forEach((btn, i) => {
    productsIds[i] = btn.dataset.productid;
  });

  const axiosData = new FormData();
  axiosData.append('action', 'toggleMultipleItemOnLikedList');
  axiosData.append('productid', productsIds);
  axiosData.append('active', !isActive);
  axios
    .post(localData.siteURL, axiosData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
      if (response.status === 200) {
        updateWishListQuantityBadge();
        // ev.target.closest('.card__wishlist-button').classList.toggle('is-liked', response.data.data.liked);
      }
    });
});

attachEvent('.recommended-products__header-button', 'click', (ev) => {
  ev.preventDefault();
  const parentButton = ev.target.closest('.recommended-products__header-button');
  const anchorHref = parentButton.querySelector('a').getAttribute('href');
  const topOffset = getOffsetTop(document.querySelector(anchorHref));

  scrollToSmoothly(topOffset, 100);
});
